import { SvgIcon, Typography } from '@material-ui/core';
import { ReactNode } from 'react';
import styled from 'styled-components';

interface PostingDescriptionProps {
  /** Omit to indent the text by the icon width. */
  icon?: ReactNode;
  label?: string;
  /** Let long text wrap instead of truncating. */
  shouldWrap?: boolean;
  children?: ReactNode;
}

const Styled1 = styled.div`
  display: flex;
  align-items: center;
`;

export function PostingDescription({
  icon,
  label,
  shouldWrap = false,
  children,
}: PostingDescriptionProps) {
  return (
    <Styled1 aria-label={label}>
      {icon ?? (
        // Empty icon of the same size, so the theme decides the indent.
        <SvgIcon fontSize="small" aria-hidden={true} visibility="hidden" />
      )}
      &nbsp;
      {shouldWrap && (
        // The label's leading space, kept outside the text block so wrapped
        // lines start at the same x as the first one.
        <Typography display="inline" component="span">
          &nbsp;
        </Typography>
      )}
      <Typography display="inline" noWrap={!shouldWrap} component="div">
        {label && (
          <Typography display="inline" color="textSecondary">
            {!shouldWrap && <>&nbsp;</>}
            {label}
          </Typography>
        )}
        {children && <>&nbsp;{children}</>}
      </Typography>
    </Styled1>
  );
}
